import styled from 'styled-components'

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    gap: 16px;
`
export const Row = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
`

export const ChangePassword = styled.div`
    font-weight: 500;
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: flex-end;
`
